<template>
    <div>
        <v-alert v-if="!!errors && errors.length > 0" type="error">
            <pre>{{ errors.join("\r\n") }}</pre>
        </v-alert>
        <signature-layout v-if="!isEmpty(registration)" :submitSignature="signPuppyRelease" :workflowGuid="registration.workflowGuid"
            :signatureId="signatureId" :foundRequest="!!registration" :isLoading="isLoading"
            :submittedAt="registration.submittedAt">
            <span slot="title">Puppy Release Confirmation</span>
            <div slot="approvedContent" v-if="registration && registration.mainColor">
                <div class="mt-5">
                    <h2>
                        <b>{{ registration.mainColor }}&nbsp;&nbsp;{{ registration.gender }}</b>
                    </h2>
                    <h2>
                        Litter #{{ registration.litterId }}
                    </h2>
                    <h3 class="mt-5">
                        <b>Ownership transfer date: </b> {{ $dateUtils.formatDate(registration.ownershipTransferDate) }}
                    </h3>
                    <h3 class="mt-5">
                        <b>May breed?: </b> {{ registration.isAllowedToBreed ? "Yes" : "No" }}
                    </h3>
                    <h3 class="mt-5">
                        <b>Required kennel name(s) in dog's name:</b>
                    </h3>
                    <ul>
                        <li v-for="kennel in registration.requiredKennels" v-bind:key="kennel.kennelId">
                            {{ kennel.kennelName }}
                        </li>
                    </ul>
                    <div class="mt-5">
                        <h2>New owner info</h2>
                        <span><b>Name: </b> {{ registration.newOwner.firstName }} {{ registration.newOwner.lastName
                        }}</span>&nbsp;&nbsp;
                        <span><b>Email: </b> {{ registration.newOwner.email }}</span>&nbsp;&nbsp;
                        <!-- <span><b>Phone number: </b> {{registration.newOwner.phoneNumber}}</span> -->
                    </div>
                </div>
            </div>
            <div slot="legalText">
                <p class="bottom-text">
                    Upon signing, I certify that this dog was transferred to the new owner on the date listed above.
                </p>
            </div>
        </signature-layout>
    </div>
</template>

<script lang="ts">
import { isEmpty } from "lodash";
import Vue from "vue";
import SignatureLayout from "@/components/common/SignatureLayout.vue";
import puppyReleaseService from '@/services/puppyReleaseService';
import { UserInfo } from "@/types/User";

export default Vue.extend({
    name: 'PuppyReleaseSignatureForm',
    components: {
        SignatureLayout
    },
    data: function () {
        return {
            signatureText: "",
            registration: {} as Object,
            isLoading: false,
            errors: [] as string[]
        };
    },
    props: {
        signatureId: { type: Number },
    },
    methods: {
        isEmpty,
        signPuppyRelease: function (workflowGuid: String, signatureId: number, personId: number, text: String) {
            puppyReleaseService.signPuppyRelease(signatureId, text)
                .then(res => {
                    if (!res.data.success) {
                        this.errors = [res.data.errorMessage]
                        return;
                    }
                    this.$router.push('/');
                })
                .catch(this.$handleError);
        }
    },
    created() {
        this.isLoading = true;
        puppyReleaseService.getPuppyReleaseDetailsForSignature(this.signatureId)
            .then(res => {
                this.isLoading = false;
                if (!isEmpty(res.data.errors)) {
                    this.errors = res.data.errors
                    return;
                }
                this.registration = res.data.data;
            })
            .catch(this.$handleError)
            .finally(() => this.isLoading = false);
    },
    watch: {
        signatureId: function (newValue) {
            this.isLoading = true;
            puppyReleaseService.getPuppyReleaseDetailsForSignature(this.signatureId)
                .then(res => {
                    this.isLoading = false;
                    if (!isEmpty(res.data.errors)) {
                        this.errors = res.data.errors
                        return;
                    }
                    this.registration = res.data.data;
                })
                .catch(this.$handleError)
                .finally(() => this.isLoading = false);
        }
    },
    computed: {
        userInfo(): UserInfo {
            return this.$store.state.userInfo;
        },
    }
});
</script>
